import Vue from 'vue'
import invoiceCom from './invoiceCom'
import invoiceRecordCom from './invoiceRecordCom'
Vue.component('invoiceCom', invoiceCom)
Vue.component('invoiceRecordCom', invoiceRecordCom)
export default {
  data() {
    return {
      col: {
        // 开票申请
        invoiceApplyBj: [
          { field: 'operation', title: '操作', width: 100, isResize: true, titleAlign: 'left', columnAlign: 'left', componentName: 'invoiceCom' },
          { field: 'invoice_status', title: '发票状态', width: 100, isResize: true, titleAlign: 'left', columnAlign: 'left',
            formatter: function(rowData, rowIndex, pagingIndex, field) {
              const type = ['待审核', '待邮寄']
              return type[rowData.invoice_status]
            },
            overflowTitle: true
          },
          { field: 'apply_time', title: '申请时间', width: 180, isResize: true, titleAlign: 'left', columnAlign: 'left', overflowTitle: true },
          { field: 'invoice_no', title: '申请编号', width: 180, isResize: true, titleAlign: 'left', columnAlign: 'left', overflowTitle: true },
          { field: 'bill_type', title: '开票类型', width: 200, isResize: true, titleAlign: 'left', columnAlign: 'left', overflowTitle: true },
          { field: 't_agent_info_agent_name', title: '渠道', width: 160, isResize: true, titleAlign: 'left', columnAlign: 'left', overflowTitle: true },
          { field: 'invoice_title', title: '发票抬头', width: 200, isResize: true, titleAlign: 'left', columnAlign: 'left', overflowTitle: true },
          { field: 'invoice_type', title: '发票类型', width: 100, isResize: true, titleAlign: 'left', columnAlign: 'left',
            formatter: function(rowData, rowIndex, pagingIndex, field) {
              const type = ['', '增值税普通发票', '增值税专用发票']
              return type[rowData.invoice_type]
            },
            overflowTitle: true
          },
          { field: 'invoice_money', title: '发票金额（元）', width: 140, isResize: true, titleAlign: 'left', columnAlign: 'left', overflowTitle: true },
          { field: 'invoice_name', title: '开具单位', width: 200, isResize: true, titleAlign: 'left', columnAlign: 'left', overflowTitle: true }
        ],
        // 开票记录
        invoiceRecordBj: [
          { field: 'operation', title: '操作', width: 100, isResize: true, titleAlign: 'left', columnAlign: 'left', componentName: 'invoiceCom' },
          { field: 'invoice_status', title: '发票状态', width: 100, isResize: true, titleAlign: 'left', columnAlign: 'left', componentName: 'invoiceRecordCom' },
          { field: 'apply_time', title: '申请时间', width: 180, isResize: true, titleAlign: 'left', columnAlign: 'left', overflowTitle: true },
          { field: 'invoice_no', title: '申请编号', width: 180, isResize: true, titleAlign: 'left', columnAlign: 'left', overflowTitle: true },
          { field: 'bill_type', title: '开票类型', width: 200, isResize: true, titleAlign: 'left', columnAlign: 'left', overflowTitle: true },
          { field: 't_agent_info_agent_name', title: '渠道', width: 160, isResize: true, titleAlign: 'left', columnAlign: 'left', overflowTitle: true },
          { field: 'invoice_title', title: '发票抬头', width: 200, isResize: true, titleAlign: 'left', columnAlign: 'left', overflowTitle: true },
          { field: 'invoice_type', title: '发票类型', width: 100, isResize: true, titleAlign: 'left', columnAlign: 'left',
            formatter: function(rowData, rowIndex, pagingIndex, field) {
              const type = ['', '增值税普通发票', '增值税专用发票']
              return type[rowData.invoice_type]
            },
            overflowTitle: true
          },
          { field: 'invoice_money', title: '发票金额（元）', width: 140, isResize: true, titleAlign: 'left', columnAlign: 'left', overflowTitle: true },
          { field: 'invoice_name', title: '开具单位', width: 200, isResize: true, titleAlign: 'left', columnAlign: 'left', overflowTitle: true }
        ],
        // 作废记录
        invoiceDiscardBj: [
          { field: 'check_time', title: '撤销时间', width: 180, isResize: true, titleAlign: 'left', columnAlign: 'left',
            formatter: function(rowData, rowIndex, pagingIndex, field) {
              return rowData.check_time
            },
            overflowTitle: true
          },
          { field: 'invoice_status', title: '发票状态', width: 100, isResize: true, titleAlign: 'left', columnAlign: 'left',
            formatter: function(rowData, rowIndex, pagingIndex, field) {
              return '已作废'
            },
            overflowTitle: true
          },
          { field: 'apply_time', title: '申请时间', width: 180, isResize: true, titleAlign: 'left', columnAlign: 'left', overflowTitle: true },
          { field: 'invoice_no', title: '申请编号', width: 180, isResize: true, titleAlign: 'left', columnAlign: 'left', overflowTitle: true },
          { field: 'bill_type', title: '开票类型', width: 200, isResize: true, titleAlign: 'left', columnAlign: 'left', overflowTitle: true },
          { field: 't_agent_info_agent_name', title: '渠道', width: 160, isResize: true, titleAlign: 'left', columnAlign: 'left', overflowTitle: true },
          { field: 'invoice_title', title: '发票抬头', width: 200, isResize: true, titleAlign: 'left', columnAlign: 'left', overflowTitle: true },
          { field: 'invoice_type', title: '发票类型', width: 100, isResize: true, titleAlign: 'left', columnAlign: 'left',
            formatter: function(rowData, rowIndex, pagingIndex, field) {
              const type = ['', '增值税普通发票', '增值税专用发票']
              return type[rowData.invoice_type]
            },
            overflowTitle: true
          },
          { field: 'invoice_money', title: '发票金额（元）', width: 140, isResize: true, titleAlign: 'left', columnAlign: 'left' },
          { field: 'invoice_name', title: '开具单位', width: 200, isResize: true, titleAlign: 'left', columnAlign: 'left', overflowTitle: true }
        ],
        // 审核-交易结算
        invoiceTrans: [
          { field: 'account_num', title: '账务流水单号', width: 180, overflowTitle: true, isResize: true },
          { field: 'statement_num', title: '业务流水单号', width: 180, overflowTitle: true, isResize: true },
          { field: 'service_type', title: '服务类型', width: 100, overflowTitle: true, isResize: true },
          { field: 'sct_no', title: '合同ID', width: 140, overflowTitle: true, isResize: true },
          { field: 'sct_name', title: '合同名称', width: 200, overflowTitle: true, isResize: true,
            formatter(rowData) {
              return `<div class='table-long' title='${rowData.sct_name}'>${rowData.sct_name}</div>`
            }
          },
          { field: 'money', title: '金额 (元)', width: 140, overflowTitle: true, isResize: true },
          { field: 'payment_date', title: '付款日期', width: 180, overflowTitle: true, isResize: true },
          { field: 'invoice_name', title: '开具单位', width: 200, overflowTitle: true, isResize: true,
            formatter(rowData) {
              return `<div class='table-long' title='${rowData.invoice_name}'>${rowData.invoice_name}</div>`
            }
          }
        ],
        // 审核-直播会议
        invoiceLive: [
          { field: 'order_no', title: '订单编号', width: 180, overflowTitle: true, isResize: true },
          { field: 'order_name', title: '服务类型', width: 200, overflowTitle: true, isResize: true,
            formatter(rowData) {
              return `<div class='table-long' title='${rowData.order_name}'>${rowData.order_name}</div>`
            }
          },
          { field: 'pay_type', title: '付款类型', width: 100, overflowTitle: true, isResize: true },
          { field: 'buy_amount', title: '数量', width: 140, overflowTitle: true, isResize: true },
          { field: 'pay_price', title: '金额（元）', width: 140, overflowTitle: true, isResize: true },
          { field: 'pay_time', title: '订购时间', width: 180, overflowTitle: true, isResize: true },
          { field: 'invoice_name', title: '开具单位', width: 200, overflowTitle: true, isResize: true,
            formatter(rowData) {
              return `<div class='table-long' title='${rowData.invoice_name}'>${rowData.invoice_name}</div>`
            }
          }
        ],
        // 审核-会员服务
        invoiceMember: [
          { field: 'order_no', title: '订单编号', width: 180, overflowTitle: true, isResize: true },
          { field: 'order_name', title: '服务类型', width: 200, overflowTitle: true, isResize: true,
            formatter(rowData) {
              return `<div class='table-long' title='${rowData.order_name}'>${rowData.order_name}</div>`
            }
          },
          { field: 'pay_type', title: '付款类型', width: 100, overflowTitle: true, isResize: true },
          { field: 'buy_amount', title: '数量', width: 140, overflowTitle: true, isResize: true },
          { field: 'pay_price', title: '金额（元）', width: 140, overflowTitle: true, isResize: true,
            formatter(rowData) {
              return `<div class='table-long' title='${rowData.pay_price || rowData.order_money}'>${rowData.pay_price || rowData.order_money}</div>`
            }
          },
          { field: 'pay_time', title: '订购时间', width: 180, overflowTitle: true, isResize: true },
          { field: 'invoice_name', title: '开具单位', width: 200, overflowTitle: true, isResize: true,
            formatter(rowData) {
              return `<div class='table-long' title='${rowData.invoice_name}'>${rowData.invoice_name}</div>`
            }
          }
        ]
      },
      detailMockData: {
        'code': 0,
        'msg': '成功',
        'result': {
          'id': 4,
          'invoice_status': 0,
          'invoice_no': 'FP1307887457609584640',
          'apply_time': '2020-09-21 11:40:44',
          'cust_name': '黑龙江吉星医药有限公司',
          'bill_type': '*信息技术服务*信息服务费',
          'invoice_type': 2,
          'invoice_money': '0.03',
          'invoice_name': '北京未来聚典信息技术有限公司',
          'invoice_tax_no': '112112112112112177',
          'invoice_addr': '12313141231',
          'invoice_bank_name': '233232322',
          'invoice_tel': '14134144342',
          'invoice_bank_no': '24242131',
          'receive_name': '121',
          'receive_addr': '天津市天津市和平区1211221',
          'receive_tel': '1221',
          'invoice_file_path': '',
          'invoice_business_apply_id': '',
          'accessory_url': 'https://image-oos.oss-cn-beijing.aliyuncs.com/file/image/1559291279630大有顺天.jpeg',
          'apply_check_list': [
            {
              'id': 9,
              'invoice_business_apply_id': 4,
              'check_status': '提交申请',
              'check_text': '',
              'check_time': '2020-09-21 11:40:44',
              'create_time': '2020-09-21 11:40:44',
              'update_time': '2020-09-21 11:40:43',
              'del_flag': 0
            }, {
              'id': 9,
              'invoice_business_apply_id': 4,
              'check_status': '申请驳回',
              'check_text': '呀呀呀呀呀呀呀呀呀呀呀呀',
              'check_time': '2020-09-21 11:40:44',
              'create_time': '2020-09-21 11:40:44',
              'update_time': '2020-09-21 11:40:43',
              'del_flag': 0
            }, {
              'id': 9,
              'invoice_business_apply_id': 4,
              'check_status': '提交申请',
              'check_text': '',
              'check_time': '2020-09-21 11:40:44',
              'create_time': '2020-09-21 11:40:44',
              'update_time': '2020-09-21 11:40:43',
              'del_flag': 0
            }
          ]
        }
      },
      detailTableMock: {
        'code': 0,
        'msg': '成功',
        'result': {
          'current_page': 1,
          'data': [
            {
              'account_num': '2008210238644420',
              'statement_num': '1597973634993',
              'service_type': '服务费',
              'sct_no': '0023',
              'sct_name': '002',
              'money': '1,234.00',
              'payment_date': '2020-08-21 09:33:55'
            },
            {
              'account_num': '2008210238644417',
              'statement_num': '1597973629352',
              'service_type': '服务费',
              'sct_no': '0023',
              'sct_name': '002',
              'money': '3,688.18',
              'payment_date': '2020-08-21 09:33:49'
            },
            {
              'account_num': '2008210238644417',
              'statement_num': '1597973629352',
              'service_type': '服务费',
              'sct_no': '0023',
              'sct_name': '002',
              'money': '3,688.18',
              'payment_date': '2020-08-21 09:33:49'
            },
            {
              'account_num': '2008210238644417',
              'statement_num': '1597973629352',
              'service_type': '服务费',
              'sct_no': '0023',
              'sct_name': '002',
              'money': '3,688.18',
              'payment_date': '2020-08-21 09:33:49'
            },
            {
              'account_num': '2008210238644417',
              'statement_num': '1597973629352',
              'service_type': '服务费',
              'sct_no': '0023',
              'sct_name': '002',
              'money': '3,688.18',
              'payment_date': '2020-08-21 09:33:49'
            },
            {
              'account_num': '2008210238644417',
              'statement_num': '1597973629352',
              'service_type': '服务费',
              'sct_no': '0023',
              'sct_name': '002',
              'money': '3,688.18',
              'payment_date': '2020-08-21 09:33:49'
            },
            {
              'account_num': '2008210238644417',
              'statement_num': '1597973629352',
              'service_type': '服务费',
              'sct_no': '0023',
              'sct_name': '002',
              'money': '3,688.18',
              'payment_date': '2020-08-21 09:33:49'
            },
            {
              'account_num': '2008210238644417',
              'statement_num': '1597973629352',
              'service_type': '服务费',
              'sct_no': '0023',
              'sct_name': '002',
              'money': '3,688.18',
              'payment_date': '2020-08-21 09:33:49'
            },
            {
              'account_num': '2008210238644417',
              'statement_num': '1597973629352',
              'service_type': '服务费',
              'sct_no': '0023',
              'sct_name': '002',
              'money': '3,688.18',
              'payment_date': '2020-08-21 09:33:49'
            },
            {
              'account_num': '2008210238644417',
              'statement_num': '1597973629352',
              'service_type': '服务费',
              'sct_no': '0023',
              'sct_name': '002',
              'money': '3,688.18',
              'payment_date': '2020-08-21 09:33:49'
            },
            {
              'account_num': '2008210238644417',
              'statement_num': '1597973629352',
              'service_type': '服务费',
              'sct_no': '0023',
              'sct_name': '002',
              'money': '3,688.18',
              'payment_date': '2020-08-21 09:33:49'
            },
            {
              'account_num': '2008210238644417',
              'statement_num': '1597973629352',
              'service_type': '服务费',
              'sct_no': '0023',
              'sct_name': '002',
              'money': '3,688.18',
              'payment_date': '2020-08-21 09:33:49'
            },
            {
              'account_num': '2008210238644417',
              'statement_num': '1597973629352',
              'service_type': '服务费',
              'sct_no': '0023',
              'sct_name': '002',
              'money': '3,688.18',
              'payment_date': '2020-08-21 09:33:49'
            }
          ],
          'first_page_url': 'http://101.201.103.211:8011/invoice/make_invoice_application_bill_detail?page=1',
          'from': 1,
          'last_page': 1,
          'last_page_url': 'http://101.201.103.211:8011/invoice/make_invoice_application_bill_detail?page=1',
          'next_page_url': null,
          'path': 'http://101.201.103.211:8011/invoice/make_invoice_application_bill_detail',
          'per_page': 15,
          'prev_page_url': null,
          'to': 2,
          'total': 2
        }
      }
    }
  }
}
